@if (
  {
    row: columnData | async,
  };
  as $
) {
  <div class="flex align-items-center">
    <strong> {{ $.row.name_primary_language }}</strong>
    <span
      class="p-1 border-round border-1 border-indigo-500 text-indigo-500 ml-2 text-xs"
      >{{ $.row.base_membership_tag }}</span
    >
  </div>
}
